import type { GroupListModel } from '@aytm/app/insights/dashboard/models/BlockModel'

import { InsightsDashboardPoolState } from '@aytm/app/insights/dashboard/duckness/ducks/types'
import { getCurrentBlock } from '@aytm/app/insights/dashboard/helpers/requests'

export type StateSelectorParams = {
  sections: GroupListModel | null
  groups: GroupListModel | null
}

export const stateSelector = (state: InsightsDashboardPoolState): StateSelectorParams => {
  const block = getCurrentBlock(state)
  const groups = state.currentSchema?.get<GroupListModel>('groups') || null
  const sections = block?.getSections() || null
  return { sections, groups }
}

export const shouldUpdate = (prev: StateSelectorParams, next: StateSelectorParams) =>
  !prev && !next ? false : prev.sections !== next.sections || prev.groups !== next.groups
